import React from 'react';
import styles from './Experience.module.css';
import { experience } from '../data/portfolio';

export default function Experience() {
  return (
    <div className="stack fade-in" style={{ marginBottom: '24px' }}>
      <div className="stack-inner">
        <div className={styles.list}>
          {experience.map((exp) => (
            <div key={exp.id} className={styles.item}>
              <div>
                <div className={styles.date}>{exp.period}</div>
                <div className={styles.company}>{exp.company}</div>
                <div className={styles.location}>{exp.location}</div>
              </div>
              <div>
                <div className={styles.role}>{exp.role}</div>
                <ul className={styles.bullets}>
                  {exp.bullets.map((b, i) => (
                    <li key={i} className={styles.bullet}>{b}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
